<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('memberManagement.email')" prop="username">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>
        <!-- TODO: 비밀번호 -->
        <el-form-item
          :label="$t('memberManagement.real_name')"
          prop="real_name"
        >
          <el-input v-model="ruleForm.real_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('memberManagement.gender')" prop="gender">
          <el-radio-group v-model="ruleForm.gender">
            <el-radio :label="1">{{ $t('memberManagement.gender1') }}</el-radio>
            <el-radio :label="0">{{ $t('memberManagement.gender0') }}</el-radio>
            <el-radio :label="2">{{ $t('memberManagement.gender2') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('memberManagement.birth')" prop="birth">
          <div class="date-picker-container">
            <el-date-picker
              v-model="ruleForm.birth"
              type="date"
              placeholder="YYYY/MM/DD"
              format="yyyy/MM/dd"
              class="date_picker"
              :pickerOptions="pickerOptions"
              default-value="2007/02/02"
              prefix-icon="none"
              clear-icon="none"
              ref="datePickerRef"
            >
            </el-date-picker>
            <img
              class="date-picker-icon"
              src="@/assets/img/calendar.png"
              @click="openDatePicker"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('memberManagement.phone')" prop="phone">
          <el-input v-model="ruleForm.phone"></el-input>
          <p class="phone-desc">* '-'를 제외하고 입력하세요.</p>
        </el-form-item>
        <el-form-item prop="address" label="주소">
          <div class="flex_column" style="gap: 8px">
            <div class="flex">
              <el-input
                v-model="ruleForm.address_code"
                placeholder="우편번호를 검색하세요."
                disabled
              ></el-input>
              <el-button
                style="width: 90px; margin-left: 16px"
                @click="searchAds"
                >검색하기</el-button
              >
            </div>
            <el-input
              v-model="ruleForm.address"
              placeholder="주소"
              disabled
            ></el-input>
            <el-input
              ref="address_detail"
              v-model="ruleForm.address_detail"
              placeholder="상세주소를 입력하세요."
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('memberManagement.delivery_request')"
          prop="delivery_request"
        >
          <el-input
            v-model="ruleForm.delivery_request"
            placeholder="배송 요청 사항을 입력하세요."
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('memberManagement.favorite_category')"
          prop="favorite_category"
        >
          <el-checkbox-group v-model="ruleForm.favorite_category">
            <div class="checkbox-container">
              <el-checkbox :label="0">문학</el-checkbox>
              <el-checkbox :label="1">인문교양</el-checkbox>
              <el-checkbox :label="2">역사</el-checkbox>
              <el-checkbox :label="3">과학</el-checkbox>
              <el-checkbox :label="4">어린이</el-checkbox>
              <el-checkbox :label="5">청소년</el-checkbox>
              <el-checkbox :label="6">그림책</el-checkbox>
              <el-checkbox :label="7">영어덜트</el-checkbox>
              <el-checkbox :label="8">만화</el-checkbox>
              <el-checkbox :label="9">기타</el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :label="$t('memberManagement.is_library')"
          prop="is_library"
        >
          <el-radio-group v-model="ruleForm.is_library">
            <el-radio :label="0">{{ $t('memberManagement.yes') }}</el-radio>
            <el-radio :label="1">{{ $t('memberManagement.no') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btn-container">
        <el-button class="btn" type="default" @click="$router.go(-1)">{{
          $t('btnTip.cancel')
        }}</el-button>
        <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
          $t('btnTip.save')
        }}</el-button>
      </div>
    </el-card>
    <el-dialog class="dialogDaum" :visible.sync="key">
      <div ref="daumBox"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="key = false">확인</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadImg from '@/components/uploadImg';
import SummerNote from '@/components/summernote';
import { memberDetail, editMember, editSerial } from '@/api/api';
import dayjs from 'dayjs';
export default {
  name: 'editMember',
  data() {
    var validatePass = (rule, value, callback) => {
      const reg = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
      if (reg.test(value) || value === '' || value === null) {
        callback();
      } else {
        callback(new Error(this.$t('carouselManagement').urlRule));
      }
    };
    return {
      key: false,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() - 1000 * 60 * 60 * 24 * 365 * 14 ||
            time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 365 * 140
          );
        },
      },
      ruleForm: {
        username: '',
        real_name: '',
        is_library: '',
        gender: 0,
        birth: '',
        phone: '',
        delivery_request: '',
        favorite_category: [],
        address: '',
        address_code: '',
        address_detail: '',
      },
      inputVisible: false,
      inputValue: '',
      rules: {
        username: [
          {
            required: true,
            message: this.$t('memberManagement').email,
            trigger: 'blur',
          },
        ],
        real_name: [
          {
            required: true,
            message: this.$t('memberManagement').real_name,
            trigger: 'blur',
          },
        ],
        is_library: [
          {
            required: true,
            message: this.$t('memberManagement').is_library,
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t('memberManagement').gender,
            trigger: 'blur',
          },
        ],
        birth: [
          {
            required: true,
            message: this.$t('memberManagement').birth,
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            trigger: ['change'],
            validator: this.validatePhone,
          },
        ],
        delivery_request: [
          {
            required: false,
            message: this.$t('memberManagement').delivery_request,
            trigger: 'blur',
          },
        ],
        favorite_category: [
          {
            required: false,
            message: this.$t('memberManagement').favorite_category,
            trigger: 'blur',
          },
        ],
        address: [{ required: true, message: '주소를 검색해 주세요.' }],
        address_code: [{ required: true, message: '주소를 검색해 주세요.' }],
        address_detail: [{ required: false, message: '주소를 검색해 주세요.' }],
      },
      options: [
        { label: this.$t('day1'), value: 0 },
        { label: this.$t('day2'), value: 1 },
        { label: this.$t('day3'), value: 2 },
        { label: this.$t('day4'), value: 3 },
        { label: this.$t('day5'), value: 4 },
      ],
      load: false,
    };
  },
  components: {
    SummerNote,
    uploadImg,
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t('btnTip').add
        : this.$t('btnTip').edit;
    },
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      this.ruleForm.birth = dayjs(this.ruleForm.birth).format('YYYY/MM/DD');
      let ruleForm = { ...this.ruleForm };

      console.log(this.id);
      await editMember(this.id, ruleForm);

      this.$router.go(-1);
    },

    async get_info() {
      const information = await memberDetail(this.id);
      this.ruleForm = { ...information };
      this.ruleForm.birth = dayjs(this.ruleForm.birth).isValid()
        ? dayjs(this.ruleForm.birth).format()
        : '1990/01/01';
      this.load = true;
    },

    openDatePicker() {
      if (this.$refs.datePickerRef) {
        this.$refs.datePickerRef.focus();
      }
    },

    validatePhone(rule, value, callback) {
      if (value.length !== 11) {
        callback(new Error('휴대폰 번호를 입력하세요.'));
      } else {
        callback();
      }
    },

    searchAds() {
      this.key = true;
      setTimeout(() => {
        new daum.Postcode({
          width: '100%',
          onComplete: (data) => {
            this.ruleForm.address_code = data.zonecode;
            if (data.userSelectedType === 'J') {
              this.ruleForm.address = data.jibunAddress;
            }
            if (data.userSelectedType === 'R') {
              if (data.buildingName !== '') {
                this.ruleForm.address =
                  data.roadAddress + ' (' + data.buildingName + ')';
              } else {
                this.ruleForm.address = data.roadAddress;
              }
            }
            this.key = false;
            this.$refs['address_detail'].focus();
          },
          onclose: () => {
            this.key = false;
          },
        }).embed(this.$refs['daumBox']);
      }, 100);
    },
  },
  async created() {
    if (this.id === undefined) {
      this.load = true;
      return;
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
}
.btn-container {
  text-align: end;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.img-guide {
  color: #808080;
}

.date-picker-container {
  width: 312px;
  position: relative;

  .date_picker {
    width: 312px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 16px;
  }

  .date-picker-icon {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    right: 8px;
  }
}

.phone-desc {
  font-size: 14px;
  color: #acb0b3;
}

.checkbox-container {
  .el-checkbox {
    margin-right: 12px;
    margin-bottom: 0;
  }
}

.flex_column {
  display: flex;
  flex-direction: column;
}
</style>
